/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content[_ngcontent-%COMP%]{width:450px}.action[_ngcontent-%COMP%]{width:100%}.text[_ngcontent-%COMP%]{margin-bottom:20px}.text2[_ngcontent-%COMP%]{font-size:13px;color:#aaaab1}@media screen and (max-width:767px){.content[_ngcontent-%COMP%]{width:250px}}.full[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
